import dynamic from 'next/dynamic'

import { memo } from 'react'
import type { Props } from './TVChart'

const TVChartContainer = dynamic(() => import('./TVChart').then((mod) => mod.TVChart), {
	ssr: false,
})

export default memo((props: Props) => <TVChartContainer {...props} />)
